module.exports = __webpack_public_path__ + "img/green_006.1a74ffac.png";